import React from 'react';
const bonuses = [{
  num: 1,
  title: 'Banco de Actividades Listas',
  desc: 'Actividades probadas listas para aplicar en cualquier momento',
  price: 'S/.15'
}, {
  num: 2,
  title: 'Kit de Juegos y Transiciones',
  desc: 'Juegos rápidos para mantener la atención entre actividades',
  price: 'S/.12'
}, {
  num: 3,
  title: 'Semana Resuelta Paso a Paso',
  desc: 'Un sistema para empezar a organizar tu semana completa',
  price: 'S/.18'
}, {
  num: 4,
  title: 'Actividades Sin Material',
  desc: 'Ideas creativas que no necesitan ningún recurso extra',
  price: 'S/.10'
}, {
  num: 5,
  title: 'Rutinas Inteligentes',
  desc: 'Detecta cuándo actuar y cuándo dejar fluir la clase',
  price: 'S/.14'
}, {
  num: 6,
  title: 'Ideas Visuales de Alto Impacto',
  desc: 'Recursos visuales que captan la atención al instante',
  price: 'S/.12'
}];
export function BonusSection() {
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-35">
      <div className="max-w-xl mx-auto" data-id="element-36">
        <div className="text-center mb-8" data-id="element-37">
          <h2 className="text-2xl md:text-3xl font-extrabold mb-2" data-id="element-38">
            🎁 PERO ESO NO ES TODO... RECIBE TAMBIEN LOS 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-39">
            Incluidos en todas las ofertas
          </p>
        </div>

        <div className="space-y-3 mb-8" data-id="element-40">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-gray-900 border-2 border-yellow-400 rounded-xl p-5 relative overflow-hidden" data-id="element-41">
              {/* GRATIS badge */}
              <div className="absolute top-3 right-3 bg-red-600 text-white text-[10px] font-black px-2.5 py-1 rounded-md flex items-center gap-1" data-id="element-42">
                🎁 GRATIS
              </div>

              {/* Bono label */}
              <div className="flex items-center gap-3 mb-2" data-id="element-43">
                <div className="bg-brand-yellow/20 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-44">
                  <span className="text-lg" data-id="element-45">🎁</span>
                </div>
                <span className="text-[11px] text-gray-500 font-bold uppercase tracking-wider" data-id="element-46">
                  BONO {bonus.num}
                </span>
              </div>

              {/* Title */}
              <h3 className="text-base font-black text-white mb-1 pr-16" data-id="element-47">
                {bonus.title}
              </h3>

              {/* Description */}
              <p className="text-xs text-gray-500 mb-3 leading-relaxed" data-id="element-48">
                {bonus.desc}
              </p>

              {/* Price */}
              <div className="flex items-center gap-2" data-id="element-49">
                <span className="text-sm text-gray-600 line-through" data-id="element-50">
                  {bonus.price}
                </span>
                <span className="text-sm font-black text-green-500" data-id="element-51">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-gray-900 border border-brand-yellow/30 rounded-xl p-6 text-center" data-id="element-52">
          <p className="text-gray-500 text-sm line-through mb-1" data-id="element-53">
            Valor total: +S/.99.99 PEN
          </p>
          <p className="text-2xl md:text-3xl font-black text-brand-yellow" data-id="element-54">
            🎁 HOY: GRATIS
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-55">
            (solo por tiempo limitado)
          </p>
        </div>
      </div>
    </section>;
}